import { useEffect, useState } from 'react'

/**
 * Checks synchronously whether the page runs inside the Hayırhah native app WebView.
 * The native shell injects `window.ReactNativeWebView` before page scripts run.
 */
export const isNativeAppWebView = () =>
  typeof window !== 'undefined' &&
  Boolean((window as unknown as { ReactNativeWebView?: unknown }).ReactNativeWebView)

/**
 * Reports whether the page runs inside the native app.
 * Starts as `false` so server and first client render match.
 */
export const useIsNativeApp = () => {
  const [isNativeApp, setIsNativeApp] = useState(false)

  useEffect(() => {
    setIsNativeApp(isNativeAppWebView())
  }, [])

  return isNativeApp
}

export default useIsNativeApp
